export default "/_next/static/images/dog2-14a3952354a82ba11e4dacc4b55b2a66.png";